module.exports = __webpack_public_path__ + "static/image1-fe2d71f00d1421bc0d851b437073d4e3.png";